var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoLive3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#46E1B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0039 37.8223V51.6463",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3926 41.2783H40.5446C42.4533 41.2783 44.0006 39.731 44.0006 37.8223",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6086 51.6465H39.3926",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9253 25.7032C41.2518 25.1819 41.7055 24.7521 42.2436 24.4542C42.7818 24.1563 43.3868 24 44.0019 24C44.6171 24 45.2221 24.1563 45.7602 24.4542C46.2984 24.7521 46.752 25.1819 47.0786 25.7032L53.0473 35.1485L60.8312 36.1022C61.4766 36.1744 62.0904 36.4213 62.6059 36.8165C63.1214 37.2117 63.5195 37.74 63.7569 38.3446C63.9944 38.9493 64.0622 39.6073 63.9534 40.2477C63.8443 40.888 63.5627 41.4865 63.1387 41.9787L56.6468 49.4242L58.739 59.731C58.8702 60.4033 58.8069 61.0993 58.556 61.7371C58.3054 62.3745 57.8779 62.9275 57.324 63.3307C56.7627 63.7265 56.1019 63.9563 55.4164 63.9944C54.731 64.0324 54.0488 63.8772 53.4473 63.546L44.0019 58.3771L34.5566 63.546C33.9552 63.8772 33.2729 64.0324 32.5874 63.9944C31.9019 63.9563 31.241 63.7265 30.68 63.3307C30.126 62.9275 29.6985 62.3745 29.4478 61.7371C29.1971 61.0993 29.1336 60.4033 29.2648 59.731L31.3569 49.4242L24.8652 41.9787C24.4411 41.4865 24.1595 40.888 24.0506 40.2477C23.9416 39.6073 24.0095 38.9493 24.2469 38.3446C24.4844 37.74 24.8823 37.2117 25.3979 36.8165C25.9134 36.4213 26.5271 36.1744 27.1727 36.1022L34.9566 35.1485L40.9253 25.7032Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLive3);
export default __webpack_public_path__ + "static/media/go_live_3.6c763c4d809b009c29ec2a6e2d4a9f4a.svg";
export { ForwardRef as ReactComponent };